/*
 * @Author: Ashley.Liu
 * @Date: 2022-06-12 16:15:23
 * @LastEditTime: 2022-12-08 10:49:25
 * @Description: desc
 */
import AsMenu from './components/menu/index'
import ASUnitConvert from './components/unitConvert/index'
import ASParse from './components/parse/index'
import ASTableColumnListPopover from './components/tableColumnListPopover'
import AsStatus from './components/status'
import AsPaginationSelect from './components/paginationSelect/index'
import AsCodeEditor from './components/codeEditor/index'
import AsRuleMap from './components/ruleMap/index'
import AsCopy from './components/copy/index.js'

import AsOmit from './directives/omit'
import AsTooltip from './directives/tooltip'
import AsCopyDirective from './directives/copy'
import AsResize from './directives/resize'
import '../assets/fonts/iconfont.css'

const COMPONENTS = [
  AsMenu,
  ASUnitConvert,
  ASParse,
  AsPaginationSelect,
  ASTableColumnListPopover,
  AsStatus,
  AsRuleMap,
  AsCopy,
]
const DIRECTIVES = [AsOmit, AsTooltip, AsCopyDirective, AsResize]

function install(Vue) {
  COMPONENTS.forEach((comp) => {
    Vue.use(comp)
  })
  DIRECTIVES.forEach((directive) => {
    Vue.directive(directive.name, directive)
  })
}

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}
const asyncUI = {
  install,
}

export default asyncUI

export { AsCodeEditor }
